<template>
  <div style="padding-bottom: 5px;">
    <div
      style="display: inline-block;width: 50%;vertical-align: middle"
      class="text-truncate"
    >{{ stock[1] }}</div>
    <div style="display: inline-block;" class="text-xs-right">
      <v-btn
        small
        fab
        color="primary"
        outline
        class="extra-small ma-0"
        v-if="!(selectedBot.useketshop == true && selectedBot.ketshop_api_key && selectedBot.ketshop_api_secret)"
        @click="removeCount()"
        :disabled="stock[2] == this.min"
      >
        <span class="fa fa-minus"></span>
      </v-btn>

      <span
        style="width: 30px;display:inline-block;margin-left:5px;margin-right:5px;text-align:center"
      >{{ stock[2] }}</span>
      <v-btn
        small
        fab
        color="primary"
        outline
        class="extra-small ma-0"
        v-if="!(selectedBot.useketshop == true && selectedBot.ketshop_api_key && selectedBot.ketshop_api_secret)"
        @click="addCount()"
        :disabled="stock[2] == this.max - 1"
      >
        <span class="fa fa-plus"></span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['value', 'productId'],
  data: function() {
    return {
      stock: this.value,
      max: 10000,
      min: 0
    }
  },
  watch: {
    value: function() {
      this.stock = this.value
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    removeCount: function() {
      if (this.stock[2] > this.min) {
        this.stock[2] = parseInt(this.stock[2]) - 1
        let stock = [this.stock[0], this.stock[1], this.stock[2], this.stock[3], this.stock[4]]
        this.updateStock()
        this.$emit('input', stock)
      }
    },
    addCount: function() {
      if (this.stock[2] < this.max) {
        this.stock[2] = parseInt(this.stock[2]) + 1
        let stock = [this.stock[0], this.stock[1], this.stock[2], this.stock[3], this.stock[4]]
        this.updateStock()
        this.$emit('input', stock)
      }
    },
    updateStock: function() {
      let vm = this
      let productstock = {
        id: vm.stock[0],
        option: vm.stock[1],
        productid: this.productId,
        quantity: vm.stock[2],
        price: vm.stock[3],
        discountprice: vm.stock[4]
      }
      api.editProductStock(productstock, function(error, response) {
        if (error) {
          console.error(error)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ananda/StockItem.vue